export default "__VITE_ASSET__DajFyHuC__"